// 地图配置

// 城市中心点配置
export const cityCenter = {
  杭州: [120.17828, 30.209437],
  苏州: [120.619585, 31.299379],
}

// 热力图选项
export const heatmapOptions = [
  {
    value: "企业",
    label: "高新企业热力图",
  },
  {
    value: "大厦",
    label: "大厦热力图",
  },
  {
    value: "楼盘点击",
    label: "楼盘点击热力图",
  },
  {
    value: "楼盘中签率",
    label: "楼盘中签率热力图",
  },
]

// 区域配置（中心点、窗口大小等）
export const areaConfig = {
  余杭区: {
    center: [120.107647, 30.334527],
    windowHeight: 4000,
    windowWidth: 5500,
  },
  萧山区: {
    center: [120.365439, 30.171065],
    windowHeight: 3200,
    windowWidth: 4500,
  },
  滨江区: {
    center: [120.192662, 30.184495],
    windowHeight: 1500,
  },
  钱塘新区: {
    center: [120.461269, 30.298242],
    windowHeight: 1500,
    windowWidth: 4200,
  },
  富阳区: {
    center: [119.965468, 30.090651],
    windowHeight: 2600,
    windowWidth: 2600,
  },
  临安区: {
    center: [119.763165, 30.248483],
    windowHeight: 1500,
    windowWidth: 2500,
  },
  西湖区: {
    center: [120.082627, 30.222455],
    windowHeight: 3500,
    windowWidth: 2000,
  },
  拱墅区: {
    center: [120.146228, 30.341713],
    windowHeight: 1500,
  },
  江干区: {
    center: [120.221158, 30.290996],
    windowHeight: 2500,
  },
  上城区: {
    center: [120.181655, 30.240232],
  },
  下城区: {
    center: [120.179338, 30.293606],
  },
}

// 全城配置
export const fullCityConfig = {
  杭州: {
    全城: {
      windowHeight: 5000,
      windowWidth: 8000,
    },
    全城左: {
      center: [119.890667, 30.293606],
      windowHeight: 11000,
      windowWidth: 5550,
    },
    全城右: {
      center: [120.367027, 30.293606],
      windowHeight: 11000,
      windowWidth: 5550,
    },
  },
  苏州: {
    全城: {
      center: [120.569185, 31.162678],
      windowHeight: 11300,
      windowWidth: 8900,
    },
    全城左: {
      center: [120.38033875, 31.162678],
      windowHeight: 11300,
      windowWidth: 4450,
    },
    全城右: {
      center: [120.75803125, 31.162678],
      windowHeight: 11300,
      windowWidth: 4450,
    },
  },
}

export default {
  cityCenter,
  heatmapOptions,
  areaConfig,
  fullCityConfig
}



// WEBPACK FOOTER //
// ./src/page/makeLocationImage/config/mapConfig.js